module.exports = __webpack_public_path__ + "static/media/fk.dd7bc357.svg";